import React, { Component } from "react";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";

import logo from "../../img/hotgiggity-logo.png";

class BookingNotFound extends Component {
    render() {
        return (
            <React.Fragment>
                <img src={logo} alt="Logo" style={{ position: "absolute", top: 16, left: 16, width: 150 }} />

                <Hidden smDown>
                    <Grid container className="error-404-container" spacing={0}>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography gutterBottom component="p" variant="display4" className="error-404">
                                403
                            </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography gutterBottom component="p" variant="headline">
                                You do not have access to this booking
                            </Typography>
                        </Grid>
                    </Grid>
                </Hidden>
            </React.Fragment>
        );
    }
}
export default BookingNotFound;
